import PropTypes from 'prop-types'
import {Button, Flex, Text, Link} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'

const PayoutAccountFallbackScreen = ({goToNextStep, onTryAgain}) => {
  const {t} = useTranslation('connectPayoutAccount')
  const {t: tCommon} = useTranslation('common')

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" gap={3} pt={20}>
        <Text
          color="black"
          fontWeight="regular"
          fontSize="2xl"
          lineHeight="90%"
          mt={8}
        >
          {t('modal.fallback.title')}
        </Text>

        <Flex flexDirection="column" gap={2} pt={6}>
          <Text
            color="black"
            fontWeight="medium"
            fontSize="sm"
            lineHeight="125%"
          >
            {t('modal.fallback.somethingWentWrong')}
          </Text>

          <Text
            color="black"
            fontWeight="medium"
            fontSize="sm"
            lineHeight="125%"
          >
            <Trans
              t={t}
              i18nKey="modal.fallback.description"
              components={{
                a: (
                  <Link
                    style={{textDecoration: 'underline'}}
                    color="primary.black"
                    href={tCommon('customerSupportEmail')}
                    rel="nofollow"
                    target="_blank"
                  />
                ),
              }}
            />
          </Text>
        </Flex>

        <Flex gap={5} pt={6}>
          <Button
            borderRadius="full"
            variant="primary"
            onClick={goToNextStep}
            _hover={{}}
          >
            {t('modal.buttons.continueAndGetHelp')}
          </Button>
          <Button
            borderRadius="full"
            variant="secondary"
            onClick={onTryAgain}
            _hover={{}}
          >
            {t('modal.buttons.tryAgain')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

PayoutAccountFallbackScreen.propTypes = {
  goToNextStep: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func.isRequired,
}

export default PayoutAccountFallbackScreen
